import axios from 'axios';
import { deepTrim } from '../utils/ways';

// axios 默认配置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['x-client'] = process.env.xClient || 'lcn_web';
axios.defaults.headers['x-client-version'] = process.env.xClientVersion || '1.0.0';
axios.defaults.timeout = 30000; // 设置30s为超时
// 超时用法：get('/placeList/detail', { id }, { isMock: false, timeout: 200 })

// 存储路由跳转时，需要cancel的接口
const requestMap = new Map();
const instance = axios.create();

/**
 * 请求拦截
 */
instance.interceptors.request.use((config: any) => {

  // get 请求时，清空参数前后空格
  if (config.method.toUpperCase() === 'GET') {
    config.params = deepTrim(config.params);
  }

  if (config.customCancelToken) { // 外部传入的手动方案token
    config.cancelToken = config.customCancelToken;
  } else if (config.cancelToken) {
    const source = axios.CancelToken.source();
    config.axiosKey = config.url.split('?')[0];
    config.cancelToken = source.token;
    // 如果存在就未完结的就cancel
    if (requestMap.has(config.axiosKey)) {
      requestMap.get(config.axiosKey).cancel();
    }
    requestMap.set(config.axiosKey, source);
  }
  return config;
});

/**
 * 结果拦截
 */
instance.interceptors.response.use((response: any) => {
  const {
    config: { axiosKey },
  } = response;
  requestMap.delete(axiosKey);
  return response;
});

export default instance;
